// import { useEffect } from 'react';

const Lead = () => {
    return (
        <div className='lead-wrapper'>
             <img src={require('../assets/img/lead-mask.png')} alt='' className="lead-mask"/>
            <div className="one-box">
                1.点击右上角图标
                <img src={require('../assets/img/lead-icon.png')} alt='' className="lead-icon"/>
            </div>
            <div className="two-bpx">
                2.选择在“在浏览器中打开”
            </div>
            <img src={require('../assets/img/browser-icon.png')} alt='' className="browser-icon"/>
            <div>
                3.即刻下载“通通APP”
            </div>
        </div>
    )
};

export default Lead;